// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Reset */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Global Container - Orijinal ile birebir aynı */
.container {
  max-width: 1290px;
  margin: 0 auto;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
 
  @media (min-width: 1200px) and (max-width: 1365px) {
    padding: 0 50px;
  }
}

.App {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


.go-top-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 50px;
  height: 50px;
  background-color: #004481;
  border: none;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  z-index: 999;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transform: translateY(20px);
  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease, background-color 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.go-top-button img {
  width: 20px;
  height: 20px;
  filter: brightness(0) invert(1);
}
.go-top-button:hover {
  background-color: #031448;
  transform: translateY(15px) scale(1.05);
}
.go-top-button.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,iBAAiB;EACjB,cAAc;;EAEd;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,oGAAoG;EACpG,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B","sourcesContent":["/* Global Reset */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Global Container - Orijinal ile birebir aynı */\n.container {\n  max-width: 1290px;\n  margin: 0 auto;\n\n  @media (max-width: 1200px) {\n    padding: 0 20px;\n  }\n \n  @media (min-width: 1200px) and (max-width: 1365px) {\n    padding: 0 50px;\n  }\n}\n\n.App {\n  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n\n.go-top-button {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  width: 50px;\n  height: 50px;\n  background-color: #004481;\n  border: none;\n  color: #fff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  z-index: 999;\n  cursor: pointer;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(20px);\n  transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease, background-color 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n.go-top-button img {\n  width: 20px;\n  height: 20px;\n  filter: brightness(0) invert(1);\n}\n.go-top-button:hover {\n  background-color: #031448;\n  transform: translateY(15px) scale(1.05);\n}\n.go-top-button.show {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
